import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const userId = localStorage.getItem('user_id'); // Assuming the user's ID is stored in localStorage
        const response = await axios.get(`${process.env.REACT_APP_API_URL || 'https://api.eatourshorts.com'}/notifications/${userId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`, // Include the JWT token
          },
        });
        setNotifications(response.data);
      } catch (err) {
        console.error('Error fetching notifications:', err);
        setError('Failed to fetch notifications.');
      }
    };

    fetchNotifications();
  }, []);

  const markAsRead = async (notificationId) => {
    try {
      await axios.patch(`${process.env.REACT_APP_API_URL || 'https://api.eatourshorts.com'}/notifications/${notificationId}/read`, {}, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`, // Include the JWT token
        },
      });
      setNotifications((prev) =>
        prev.map((notification) =>
          notification.id === notificationId ? { ...notification, is_read: true } : notification
        )
      );
    } catch (err) {
      console.error('Error marking notification as read:', err);
      setError('Failed to mark notification as read.');
    }
  };

  return (
    
    <div
      style={{
        padding: '20px',
        fontFamily: 'Arial, sans-serif',
        color: '#333',
        backgroundColor: '#f9f9f9',
        minHeight: '100vh',
      }}
    >

      <h1 style={{ color: '#007bff', marginBottom: '20px' }}>Notifications</h1>
      {error && (
        <p
          style={{
            color: 'red',
            backgroundColor: '#ffe6e6',
            padding: '10px',
            borderRadius: '5px',
            border: '1px solid #ffcccc',
            marginBottom: '20px',
          }}
        >
          {error}
        </p>
      )}
      {notifications.length > 0 ? (
        <ul style={{ listStyleType: 'none', padding: 0 }}>
          {notifications.map((notification) => (
            <li
              key={notification.id}
              style={{
                marginBottom: '15px',
                backgroundColor: notification.is_read ? '#f0f0f0' : '#fff',
                padding: '15px',
                border: '1px solid #ccc',
                borderRadius: '5px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
              }}
            >
              <p style={{ margin: 0, fontSize: '16px', fontWeight: 'bold' }}>
                {notification.message}
              </p>
              <p style={{ fontSize: '12px', color: '#888', marginTop: '5px' }}>
                {new Date(notification.created_at).toLocaleString()}
              </p>
              {!notification.is_read && (
                <button
                  onClick={() => markAsRead(notification.id)}
                  style={{
                    marginTop: '10px',
                    padding: '8px 12px',
                    backgroundColor: '#007bff',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    fontSize: '14px',
                    cursor: 'pointer',
                    transition: 'background-color 0.2s',
                  }}
                  onMouseEnter={(e) => (e.target.style.backgroundColor = '#0056b3')}
                  onMouseLeave={(e) => (e.target.style.backgroundColor = '#007bff')}
                >
                  Mark as Read
                </button>
              )}
            </li>
          ))}
        </ul>
      ) : (
        <p
          style={{
            color: '#666',
            fontSize: '16px',
            textAlign: 'center',
            marginTop: '20px',
          }}
        >
          No notifications found.
        </p>
      )}


      <button
        onClick={() => navigate('/dashboard')}
        style={{
          marginTop: '20px',
          padding: '10px 20px',
          backgroundColor: '#6c757d',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          fontSize: '16px',
          cursor: 'pointer',
          transition: 'background-color 0.2s',
        }}
        onMouseEnter={(e) => (e.target.style.backgroundColor = '#5a6268')}
        onMouseLeave={(e) => (e.target.style.backgroundColor = '#6c757d')}
      >
        Back to Dashboard
      </button>
</div>


  );
};

export default Notifications;